import Image from '../../components/Image'
import { Product } from '../../types'

type ProductSectionProps = {
  readonly products: ReadonlyArray<{
    readonly product: Product
    readonly description: string
    readonly productTitle: string
    readonly productSecondTitle: string
    readonly buttonText: string
    readonly title: string
    readonly images: {
      readonly src: string
      readonly altText?: string
    }[]
  }>
}

export default function ProductSection({ products }: ProductSectionProps) {
  return (
    <section>
      <div style={{ height: 1, backgroundColor: 'black' }} />

      <ul>
        {products.map(
          ({
            product,
            description,
            buttonText,
            productSecondTitle,
            productTitle,
            images,
            title,
          }) => {
            return (
              <li key={product.id} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                <a href={product.productPageUrl} data-testid='product-section-navigation-link'>
                  <h2>{productTitle}</h2>

                  <p>{productSecondTitle}</p>

                  <div key={product.id} style={{ display: 'flex', gap: '20px', cursor: 'pointer' }}>
                    <div>
                      <p style={{ fontWeight: 'bold' }}>{title}</p>

                      <p>{description}</p>

                      <button>{buttonText ?? 'Zum Produkt'}</button>
                    </div>

                    <Image
                      src={images[0].src}
                      alt={images[0].altText ?? ''}
                      width={270}
                      height={270}
                    />
                  </div>
                </a>
              </li>
            )
          },
        )}
      </ul>
    </section>
  )
}
